module.exports = __webpack_public_path__ + "media/images/icons/twotone/pushpin-02af634f6767bdb48a4f1fc355c1910d.svg";